import { TQuestion, TQuestionInput } from 'src/store/state'
import { getStructureID } from 'src/scripts/utilities'

/*---
 * adapt api response
 */
export const adaptQuestion = (resQuestions) => {
  const questions:TQuestionInput[] = []
  resQuestions.forEach((question) => {
    questions.push({
      text: question.question_string,
      value: question.question_id,
      exclusive: question.question_exclusive_flg || undefined,
      emphasis: question.question_emphasis_flg || undefined
    })
  })
  return questions
}

export const adaptQuestionType = (resQuestionType) => {
  let result = resQuestionType
  switch (resQuestionType) {
    case 'button':
      result = 'radio'
      break
  }
  return result
}

export const adaptMessageImage = (id) => {
  let result = ''
  switch (id) {
    case 'btn_value_or_performance':
      result = 'top/talk/img_8.gif'
      break
    default: break
  }
  return result
}

export const adaptImage = (formID) => {
  let result = ''
  switch (formID) {
    case 'btn_driving_frequency':
      result = 'top/talk/img_1.gif'
      break
    case 'chk_driving_use':
      result = 'top/talk/img_2.gif'
      break
    case 'btn_gender':
      result = 'top/talk/img_4.gif'
      break
    case 'chk_passenger':
      result = 'top/talk/img_7.gif'
      break
    case 'btn_focused_performance':
      result = 'top/talk/img_6.gif'
      break
    default: break
  }
  return result
}

export const adaptCustom = (formID, custom:string = '') => {
  let result = ''
  if (custom) return custom
  switch (formID) {
    case 'btn_not_result':
      result = 'nottire'
      break
    case 'obj_vehicle_type':
      result = 'maker_car'
      break
    case 'obj_tire_size':
      result = 'tire'
      break
    case 'obj_result_action':
      result = 'result'
      break
    case 'btn_error_restart':
      result = 'error_restart'
      break
    default: break
  }
  return result
}

export const adaptResponse = (response, state, customID:string = '') => {
  const questions = adaptQuestion(response.question_array)
  const type = adaptQuestionType(response.question_type)
  const image = adaptImage(response.form_id)
  const brand_array = response.brand_array ? response.brand_array : []
  const positioning_map = response.positioning_map ? response.positioning_map : ''
  const ec_banner_flg = response.ec_banner_flg ? response.ec_banner_flg : false
  const shop_banner_flg = response.shop_banner_flg ? response.shop_banner_flg : false

  // MEMO: customID = resultbody,resultother
  const custom = adaptCustom(response.form_id, customID)
  const id = response.form_id + getStructureID(response.form_id, state)
  const result:TQuestion = {
    id,
    text: response.question_string,
    checkLimit: response.question_max_length || undefined,
    image,
    type,
    questions,
    custom,
    brand_array,
    positioning_map,
    ec_banner_flg,
    shop_banner_flg
  }

  return result
}

